
import { useEffect, useRef } from "react";
import { useLanguage } from "@/contexts/LanguageContext";

const Awards = () => {
  const sectionRef = useRef<HTMLElement>(null);
  const { t } = useLanguage();

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("revealed");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    const elementsToObserve = sectionRef.current?.querySelectorAll(".reveal-on-scroll");
    elementsToObserve?.forEach((el) => {
      observer.observe(el);
    });

    return () => {
      elementsToObserve?.forEach((el) => {
        observer.unobserve(el);
      });
    };
  }, []);

  return (
    <section ref={sectionRef} id="awards" className="py-20 bg-gradient-to-b from-white dark:from-gray-900 to-blue-50 dark:to-gray-850 transition-colors duration-300">
      <div className="container mx-auto px-6">
        <h2 className="text-3xl md:text-4xl font-bold mb-12 text-center reveal-on-scroll dark:text-gray-50">
          {t('awards_title')}
        </h2>
        
        <div className="max-w-3xl mx-auto text-center reveal-on-scroll">
          <div className="flex justify-center mb-8">
            <a 
              href="https://www.amsia.nl/article/presenting-the-28-pre-finalists-of-amsia-2025/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="block hover:opacity-90 transition-opacity"
            >
              <img 
                src="https://sooovuvamgyafqsqehbo.supabase.co/storage/v1/object/public/images/asi.png" 
                alt="Amsterdam Science & Innovation Award Logo" 
                className="h-40 object-contain"
                loading="lazy"
                decoding="async"
                width="160"
                height="160"
              />
            </a>
          </div>
          
          <p className="text-xl font-medium text-gray-800 dark:text-gray-100">
            {t('awards_description')}
          </p>
          <p className="text-gray-600 dark:text-gray-400 mt-2">
            {t('awards_details')} - <a 
              href="https://www.amsia.nl/article/presenting-the-28-pre-finalists-of-amsia-2025/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-primary hover:underline"
            >
              {t('awards_read_more')}
            </a>
          </p>
        </div>
      </div>
    </section>
  );
};

export default Awards;
